import Icon from "~/components/shared/Icon";
import { shortCommit } from "~/lib/commits";

const CommitSha = ({
  commitSha,
  repoUrl,
}: {
  commitSha: string;
  repoUrl: string | null | undefined;
}) => {
  const truncatedSha = shortCommit(commitSha, 10);

  if (repoUrl) {
    let icon;
    const { hostname } = new URL(repoUrl);

    if (hostname.includes("github")) {
      icon = "github";
    } else if (hostname.includes("gitlab")) {
      icon = "gitlab";
    } else if (hostname.includes("bitbucket")) {
      icon = "bitbucket";
    } else {
      icon = "git";
    }

    return (
      <a
        className="color-inherit monospace flex items-center no-underline hover:underline"
        href={`${repoUrl}/commit/${commitSha}`}
      >
        <Icon
          data-testid={icon}
          icon={icon}
          className="mr-1 flex-none"
          style={{ width: 14, height: 14 }}
        />
        {truncatedSha}
      </a>
    );
  }

  return <span className="color-inherit monospace">{truncatedSha}</span>;
};

export default CommitSha;
